export enum BillingUnit {
    Project = "Project",
    User = "User"
}